export default __webpack_public_path__ + "static/media/bs2.1.54a5134d.png";